import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPagedCollectionResult, mapCollection } from '@mango/core';

@Injectable()
export class SupportService {

    constructor(private http: HttpClient) {

    }
    
}